module.exports = __webpack_public_path__ + "static/media/7.8c71f471.jpg";